module.exports = __webpack_public_path__ + "img/om_inter_ring.8e3daa84.png";